export const mutations = {
  setClub: (state, payload) => {
    console.log("clubId before commit:", payload);
    state.club = payload;
  },
  setClubs: (state, payload) => {
    state.clubs = payload;
  },
  setClubInfo: (state, payload) => {
    state.clubInfo = payload;
  },
  setGroupList: (state, payload) => {
    state.groupList = payload;
  },
  setClubTerms: (state, payload) => {
    state.clubTerms = payload;
  },

};
